import React from 'react';
const PATHS = {
  FREE: <><circle cx="24" cy="24" r="19" /><path d="m14 24 7 7 14-15" /></>,
  STAGED: <><path d="m5 13 19-9 19 9v23l-19 9-19-9zM5 13l19 10 19-10M24 23v22M14 9l20 10" /></>,
  OUTGOING: <><path d="M3 10h25v25H3zM28 18h9l8 10v7H28" /><circle cx="12" cy="37" r="5" /><circle cx="36" cy="37" r="5" /></>,
  RETURN: <><path d="M17 8 5 20l12 12M6 20h24a13 13 0 0 1 0 26" /></>,
  LOADING: <><path d="M4 8h18v18H4zM27 26h17v18H27zM4 31h18v13H4zM13 8v9M35 26v9" /></>,
  WAITING: <><circle cx="24" cy="24" r="19" /><path d="M24 11v15l10 6" /></>,
  DELAYED: <><path d="M24 4 46 43H2zM24 17v12M24 36v1" /></>,
  BLOCKED: <><circle cx="24" cy="24" r="19" /><path d="m11 11 26 26" /></>,
  OUT_OF_SERVICE: <><path d="M24 3v23M13 9a19 19 0 1 0 22 0" /></>,
  link: <><path d="m20 29 9-9M16 32l-3 3a8 8 0 0 1-11-11l10-10a8 8 0 0 1 11 0M32 16l3-3a8 8 0 0 1 11 11L36 34a8 8 0 0 1-11 0" transform="translate(0 -1)" /></>,
  arrow: <path d="M3 24h40M27 7l17 17-17 17" />,
};
export default function DisplayIcon({ name, className = '' }) {
  return <svg className={'tv-icon ' + className} viewBox="0 0 48 48" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">{PATHS[name] || PATHS.WAITING}</svg>;
}
